export default "__VITE_ASSET__BGPLnDLF__"